import React from 'react'
import "./Rewards.css"
import Rewards_banner from './rewards_banner/Rewards_banner'
import Contribution from '../../home/contribution/Contribution'
import Rewards_cards from './rewards_cards/Rewards_cards'

function Rewards() {
    return (
        <>
            <section className='Rewards'>
                <div className="container">
                    <Rewards_banner />
                    <Rewards_cards />
                    <Contribution />
                </div>
            </section>
        </>
    )
}

export default Rewards